import styled from 'styled-components';

export const List = styled.div`
  grid-template-columns: ${props => (!props.three ? `repeat(auto-fill, minmax(635px, 1fr))` : `repeat(auto-fill, minmax(410px, 1fr))`)};
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  }
`;
